import { Directive, Input, Output, EventEmitter, ElementRef, OnInit, OnDestroy, Renderer2 } from "@angular/core";

@Directive({
    selector: "[listKeyboardNavigation]",
})
export class KeyboardNavigationDirective implements OnInit, OnDestroy {
    @Input() items: any[] = [];
    @Input() overlayVisible: boolean = false;
    @Input() inputRef!: HTMLElement;
    @Output() itemSelected = new EventEmitter<any>();

    private selectedIndex = -1;
    private elements: HTMLElement[] = [];
    private removeKeyListener!: () => void;

    constructor(
        private host: ElementRef<HTMLElement>,
        private renderer: Renderer2
    ) {}

    // INITIALIZATION & DESTRUCTION

    ngOnInit(): void {
        if (this.inputRef) {
            this.removeKeyListener = this.renderer.listen(this.inputRef, "keydown", (event: KeyboardEvent) =>
                this.handleKeyDown(event)
            );
        }
    }

    ngOnDestroy(): void {
        if (this.removeKeyListener) {
            this.removeKeyListener();
        }
    }

    // keyboard event handler

    private handleKeyDown(event: KeyboardEvent) {
        console.log("event: ", event);
        if (!this.overlayVisible || !this.items?.length) return;

        switch (event.key) {
            case "ArrowDown":
                this.move(1);
                event.preventDefault();
                break;

            case "ArrowUp":
                this.move(-1);
                event.preventDefault();
                break;

            case "Enter":
                this.select();
                event.preventDefault();
                break;

            case "Escape":
                this.reset();
                break;
        }
    }

    // core logic

    private move(step: number) {
        this.cacheElements();
        if (!this.elements.length) return;

        const newIndex = (this.selectedIndex + step + this.elements.length) % this.elements.length;

        this.updateActive(newIndex);
    }

    private updateActive(newIndex: number) {
        if (this.selectedIndex >= 0) {
            this.elements[this.selectedIndex]?.classList.remove("focused");
        }

        this.selectedIndex = newIndex;

        const el = this.elements[this.selectedIndex];
        if (!el) return;

        el.classList.add("focused");
        this.smoothScroll(el);
    }

    private smoothScroll(el: HTMLElement) {
        const container = this.host.nativeElement;

        const styles = window.getComputedStyle(container);
        const paddingBottom = parseInt(styles.paddingBottom || "0", 10);

        const containerRect = container.getBoundingClientRect();
        const elRect = el.getBoundingClientRect();

        const visibleBottom = containerRect.bottom - paddingBottom;

        if (elRect.bottom > visibleBottom) {
            container.scrollTop += elRect.bottom - visibleBottom;
        }

        if (elRect.top < containerRect.top) {
            container.scrollTop -= containerRect.top - elRect.top;
        }
    }

    private select() {
        if (this.selectedIndex >= 0) {
            this.itemSelected.emit(this.items[this.selectedIndex]);
            this.reset();
        }
    }

    private reset() {
        if (this.selectedIndex >= 0) {
            this.elements[this.selectedIndex]?.classList.remove("focused");
        }
        this.selectedIndex = -1;
    }

    private cacheElements() {
        this.elements = Array.from(this.host.nativeElement.querySelectorAll<HTMLElement>("[data-keyboard-item]"));
    }
}
